/***
 * @Author: zsh
 * @Date: 2020-06-23 10:06:43
 * @LastEditors: zsh
 * @LastEditTime: 2020-07-08 15:19:30
 * @FilePath: /official-website/src/main.js
 **/
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";

/* 路由 */
import router from "./router";

/* axios */
import request from "./api/request";
import api from "./api/api";
Vue.prototype.$api = api;
Vue.prototype.$get = request.get;
Vue.prototype.$post = request.post;
Vue.prototype.$postForm = request.postForm;

import "lib-flexible";

/* swiper */
import "swiper/dist/css/swiper.min.css";

/* 重置样式 */
import "./assets/css/reset.min.css";

/* jquery */
import "jquery";

/* bootstarp */
import "./assets/css/bootstrap.min.css";
import "./assets/js/bootstrap.min";

/* animate.css */
import "animate.css";

// 地址选择器
import VDistpicker from "v-distpicker";
Vue.component("v-distpicker", VDistpicker);

/* 头部组件 */
import Header from "./components/Header";
Vue.component(Header.name, Header);

/* 尾部组件 */
import Footer from "./components/Footer";
Vue.component(Footer.name, Footer);

/* 回到顶部 */
import GoTop from "./components/GoTop";
Vue.component(GoTop.name, GoTop);

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // if (to.path) {
  //   _hmt.push(["_trackPageview", "/#" + to.fullPath]);
  // }
  next();
});

new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js